import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import { Dropdown } from 'react-bootstrap';

import ls from 'local-storage';
var _ = require('lodash');
export default class TemplateList extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
      
        this.state = {
            data: {
                rows: [{ serial: "", name: "Nothing exists.  Create something new!", actions: "" }]
            }, template: "",       
            teamId: ls.get('currentTeam') || this.props.currentTeam,
            teamName:"",
            tempList: [],
            canDelete: false
        };
        this.getcolumns();
       
    }

    async getTemplateList() {
      
        const resp = await fetch('api/template/templatelist?teamId=' + encodeURIComponent(this.state.teamId), {
            method: 'GET',
            credentials: 'same-origin'

        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();

                if (this._isMounted) {

                    this.setState({ tempList: jdata.templates, canDelete: jdata.canDelete }, () => this.mapRows(jdata.templates));
                    this.setState({ teamName: jdata.teamName + " is the currently selected team"});

                }

            } catch (e) {
                // //console.log(resp.statusText);
                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });            
        }
    }
    copyTemplate = async (templateId) => {
        if (!window.confirm("Create a copy of this template?")) return;
        //console.log(templateId);
        try {
            const resp = await fetch('api/template/copytemplate', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(
                     templateId
                )
            });

            if (!resp.ok) {
                alert("Copy failed. Please try again.");
                return;
            }

            // Refresh list after copy
            await this.getTemplateList();
        }
        catch (err) {
            //console.error("Copy failed", err);
            alert("Copy failed. Please try again.");
        }
    };
    deleteTemplate = async (file) => {
        if (this._deleteInProgress) return;
        if (!window.confirm(`Delete the collection "${file.name}"?\n\nIts collection link will stop working. The original Google documents will not be deleted.`)) return;
        this._deleteInProgress = true;
        const teamId = this.state.teamId;
        try {
            const response = await fetch('api/template/deletetemplate/' + encodeURIComponent(file.id), {
                method: 'DELETE',
                credentials: 'same-origin'
            });
            if (!response.ok) {
                alert(response.status === 403 ? 'Only the team owner can delete collections.' :
                    response.status === 401 ? 'Please sign in again before deleting this collection.' :
                    'The collection could not be deleted. Refresh the list and try again.');
                return;
            }
            if (this._isMounted && this.state.teamId === teamId) {
                const remaining = this.state.tempList.filter(item => item.id !== file.id);
                this.setState({ tempList: remaining }, () => this.mapRows(remaining));
            }
        } catch (error) {
            alert('Could not confirm deletion. Refresh the list before trying again.');
        } finally {
            this._deleteInProgress = false;
        }
    };
    shareTemplate = async (file) => {
        const viewUrl = `${window.location.origin}/view/${file.team}/${file.code}`;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: file.name,
                    text: "Check out this collection",
                    url: viewUrl
                });
            } catch (err) {
                //console.log("Share cancelled or failed", err);
            }
        } else {
            // Fallback to copy link modal
            navigator.clipboard.writeText(viewUrl);
            alert("Link copied to clipboard");
        }
    };

    componentDidMount() {
        this._isMounted = true;
        (async () => {
            this.getTemplateList()
        })();
    }
    async componentDidUpdate(prevProps) {
        
        if (this.props.currentTeam !== prevProps.currentTeam) {
          
            await this.setState({ teamId: this.props.currentTeam });

            await this.getTemplateList();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    mapRows(listToMap) {
        let count = 1;        
   
        const rows = listToMap.map(file => {
            const row = { ...file };
            //  debugger
            row.serial = count;
            row.name = <Link to={"/list/" + file.id} className="text-dark">{file.name}</Link>;
            row.actions = 

            <Dropdown alignRight>
                <Dropdown.Toggle size="sm" variant="secondary">
                    Actions
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item as={Link} to={"/list/" + file.id}>
                        Edit
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => this.copyTemplate(file.id)}>
                        Copy
                    </Dropdown.Item>

                    <Dropdown.Item
                        as={Link}
                        to={"/view/" + file.team + "/" + file.code}
                        target="_blank"
                    >
                        View
                    </Dropdown.Item>

                    <Dropdown.Divider />

                    <Dropdown.Item onClick={() => this.shareTemplate(file)}>
                        Share
                    </Dropdown.Item>
                    {this.state.canDelete && <Dropdown.Divider />}
                    {this.state.canDelete &&
                        <Dropdown.Item className="text-danger" onClick={() => this.deleteTemplate(file)}>
                            Delete
                        </Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>


            count++;
            return row;
        });
        let _state = this.state;
        _state.data.rows = rows;
        this.setState(_state);
    }
    getcolumns() {
        let _state = this.state;
        _state.data.columns = [];
        //_state.data.columns.push({ label: 'Serial Number', field: 'serial', sort: 'asc', width: 150 });
        _state.data.columns.push({ label: 'Name', field: 'name', sort: 'asc' });
        _state.data.columns.push({ label: '', field: 'actions', sort: 'asc' });
        this.setState(_state);
    }


    render() {

        const addButton = (<div> Collections <Link to="/list/0" className="btn btn-primary btn-new-list"><i className="fa fa-plus"></i> New </Link></div>);
        const teamButton = (<div> Collections <Link to="/teams" className="btn btn-primary btn-new-list "><i className="fa fa-plus"></i> Please select a Team above, or create a new one </Link></div>);
        const header = this.state.teamId === '0' ?   teamButton :addButton;
        const teamName = this.state.teamName;
        return (
            <div>
                <h2>{header}</h2>
                <h3>{teamName} </h3>
                        <MDBDataTable
                            className="lists-table"
                            noRecordsFoundLabel="Nothing found. Create something new!"
                            displayEntries={false}
                            entries={50}
                            striped
                            bordered
                            hover
                            data={_.cloneDeep(this.state.data)}
                        />
                {/* <div className="container-fluid">
                    {this.state.tempList.length>0 ? 
                        this.state.tempList.map(file => <TemplateItem key={file.id} {...file}  />) :
                        <div>There are no lists for the selected team yet.</div>}
                </div>
                <br />
                <div className="row">
                  
                    <div className="col-sm"><Link to="/list/0" className="btn btn-secondary">New List </Link></div>
                </div>*/}


                
            </div>
        );
    }
}


